<div #pantallaCompletaRoot class="grafico-pantalla-completa-root" [class.grafico-overlay-activo]="modalAbierto">
    <ion-card class="grafico-evolucion-card">
        <ion-card-header>
            <div class="header-container">
                <div class="header-fila-superior">
                    <div class="titulo-container">
                        <ion-card-title>{{ titulo }}</ion-card-title>
                    </div>
                    <div class="acciones-header">
                        <ion-button *ngIf="informacion" [id]="idUnico" fill="clear" size="small" class="boton-informacion"
                            aria-label="Información">
                            <ion-icon name="information-circle-outline" slot="icon-only"></ion-icon>
                        </ion-button>
                        <ion-button *ngIf="!modalAbierto" class="boton-pantalla-completa" fill="clear" size="small"
                            [disabled]="cargando || datos.length === 0"
                            (click)="abrirPantallaCompleta()"
                            aria-label="Ver gráfico en pantalla completa">
                            <ion-icon name="expand-outline" slot="icon-only"></ion-icon>
                        </ion-button>
                        <ion-button *ngIf="modalAbierto" class="btn-cerrar-fullscreen" fill="clear" size="small"
                            (click)="cerrarPantallaCompleta()" aria-label="Cerrar pantalla completa">
                            <ion-icon name="close-outline" slot="icon-only"></ion-icon>
                        </ion-button>
                    </div>
                </div>
                <div class="subtitulo-fila">
                    <ion-card-subtitle *ngIf="subtitulo">{{ subtitulo }}</ion-card-subtitle>
                    <div class="selectores-header">
                        <div class="selector-estado">
                            <ion-select [value]="estadoActual" (ionChange)="onEstadoChange($event)" interface="popover"
                                class="select-estado"
                                [interfaceOptions]="opcionesSelectEstadoModal">
                                <ion-select-option *ngFor="let opcion of opcionesEstado" [value]="opcion.valor">
                                    {{ opcion.label }}
                                </ion-select-option>
                            </ion-select>
                        </div>

                        <div class="selector-periodo">
                            <ion-select [value]="periodoActual" (ionChange)="onPeriodoChange($event)" interface="popover"
                                class="select-periodo"
                                [interfaceOptions]="opcionesSelectPeriodoModal">
                                <ion-select-option *ngFor="let opcion of opcionesPeriodo" [value]="opcion.valor">
                                    {{ opcion.label }}
                                </ion-select-option>
                            </ion-select>
                        </div>

                    </div>
                </div>

            </div>
        </ion-card-header>
        <ion-card-content>
            <div class="loading-container" *ngIf="cargando && datos.length === 0">
                <ion-spinner name="crescent"></ion-spinner>
                <p>Cargando datos...</p>
            </div>

            <div class="sin-datos" *ngIf="!cargando && datos.length === 0">
                <ion-icon name="bar-chart-outline"></ion-icon>
                <p>No hay datos disponibles</p>
            </div>

            <div class="grafico-contenedor" *ngIf="datos.length > 0">
                <div class="loading-container loading-container--overlay" *ngIf="cargando || !graficoListo">
                    <ion-spinner name="crescent"></ion-spinner>
                    <p>Cargando datos...</p>
                </div>
                <div class="grafico-fullscreen-body" [class.grafico-fullscreen-body--activo]="modalAbierto">
                    <div class="grafico-wrapper" [class.grafico-listo]="graficoListo"
                        [class.grafico-fullscreen-contenido]="modalAbierto">
                        <canvas #graficoCanvas></canvas>
                    </div>
                    <app-grafico-fullscreen-tabla *ngIf="modalAbierto"
                        [columnas]="columnasTablaFullscreen"
                        [filas]="filasTablaFullscreen">
                    </app-grafico-fullscreen-tabla>
                </div>
            </div>
        </ion-card-content>
    </ion-card>
</div>

<ion-popover *ngIf="informacion" [trigger]="idUnico" triggerAction="click" reference="trigger"
  [side]="modalAbierto ? 'bottom' : 'top'" alignment="center"
  [cssClass]="modalAbierto ? 'popover-grafico-fullscreen' : undefined"
  [showBackdrop]="modalAbierto" [backdropDismiss]="modalAbierto ? true : undefined">
    <ng-template>
        <div class="popover-informacion">
            <p>{{ informacion }}</p>
        </div>
    </ng-template>
</ion-popover>
